import type { LucideIcon } from "lucide-react";
import { ShieldOffIcon } from "lucide-react";

type EventDetailPermissionNoticeProps = {
  title: string;
  description: string;
  icon?: LucideIcon;
  className?: string;
};

export function EventDetailPermissionNotice({
  title,
  description,
  icon: Icon = ShieldOffIcon,
  className = "mt-6",
}: EventDetailPermissionNoticeProps) {
  return (
    <section
      className={`rounded-xl border border-dashed bg-muted/20 px-5 py-8 text-center ${className}`}
    >
      <Icon className="mx-auto mb-3 size-8 text-muted-foreground" />
      <p className="font-medium text-sm">{title}</p>
      <p className="mt-1 text-muted-foreground text-sm">{description}</p>
    </section>
  );
}
